export enum UsageGaugeDimension {
    ResourceId = 'resourceId',
    TeamId = 'teamId',
    Service = 'service',
    ResourceType = 'resourceType',
    Ordinal = 'ordinal',
}
